var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconTwitter = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 369.37 300",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.61,74.53c.11,3.3.22,6.59.22,9.88C331.83,184.52,255.65,300,116.14,300A214.06,214.06,0,0,1,0,266a163.37,163.37,0,0,0,18.11,1.1,151.78,151.78,0,0,0,94.18-32.49,75.92,75.92,0,0,1-70.8-52.69,75.66,75.66,0,0,0,14.27,1.32,74.85,74.85,0,0,0,20-2.64,75.74,75.74,0,0,1-60.81-74.31v-1a74.41,74.41,0,0,0,34.36,9.44,75.66,75.66,0,0,1-23.6-101A215,215,0,0,0,181.89,93a74.51,74.51,0,0,1-2-17.23A75.8,75.8,0,0,1,311,23.93,150.88,150.88,0,0,0,359.17,5.49,76.06,76.06,0,0,1,325.8,47.42a152.89,152.89,0,0,0,43.57-12A153.74,153.74,0,0,1,331.61,74.53Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconTwitter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-twitter.a93c6700.svg";
export { ForwardRef as ReactComponent };